import { SearchProps } from './interface'

export function detectMessage(error?: boolean, resultMessage?: SearchProps['resultMessage']) {
  if (error) {
    // brain（検索エンジン）の一時的な失敗などで取得できなかった場合。
    // 「該当なし」と誤認させないよう、エラーである旨とリトライを促す。
    return resultMessage?.error || '検索できませんでした。時間を空けて再度お試しください。'
  }
  return resultMessage?.success || '該当はありません'
}
